import { render, staticRenderFns } from "./LocationProduct.vue?vue&type=template&id=27ef7174&scoped=true"
import script from "./LocationProduct.vue?vue&type=script&lang=js"
export * from "./LocationProduct.vue?vue&type=script&lang=js"
import style0 from "./LocationProduct.vue?vue&type=style&index=0&id=27ef7174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ef7174",
  null
  
)

export default component.exports